// Change this address to update every contact link on the website.
// Rebuild after changing it; automatic deployment is currently disabled.
export const siteConfig = {
  contactEmail: 'padmarajpalas@gmail.com',
};
